var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3581 25.2106H26.6999L26.1122 24.6439C28.1692 22.2511 29.4076 19.1446 29.4076 15.7653C29.4076 8.23004 23.2996 2.12207 15.7643 2.12207C8.22906 2.12207 2.12109 8.23004 2.12109 15.7653C2.12109 23.3006 8.22906 29.4085 15.7643 29.4085C19.1436 29.4085 22.2501 28.1701 24.6429 26.1132L25.2096 26.7009V28.359L35.7044 38.8328L38.8319 35.7054L28.3581 25.2106V25.2106ZM15.7643 25.2106C10.5379 25.2106 6.31901 20.9917 6.31901 15.7653C6.31901 10.5389 10.5379 6.31999 15.7643 6.31999C20.9907 6.31999 25.2096 10.5389 25.2096 15.7653C25.2096 20.9917 20.9907 25.2106 15.7643 25.2106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3581 25.2106H26.6999L26.1122 24.6439C28.1692 22.2511 29.4076 19.1446 29.4076 15.7653C29.4076 8.23004 23.2996 2.12207 15.7643 2.12207C8.22906 2.12207 2.12109 8.23004 2.12109 15.7653C2.12109 23.3006 8.22906 29.4085 15.7643 29.4085C19.1436 29.4085 22.2501 28.1701 24.6429 26.1132L25.2096 26.7009V28.359L35.7044 38.8328L38.8319 35.7054L28.3581 25.2106V25.2106ZM15.7643 25.2106C10.5379 25.2106 6.31901 20.9917 6.31901 15.7653C6.31901 10.5389 10.5379 6.31999 15.7643 6.31999C20.9907 6.31999 25.2096 10.5389 25.2096 15.7653C25.2096 20.9917 20.9907 25.2106 15.7643 25.2106Z",
    fill: "#007DFF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7331 23.5856H25.0749L24.4872 23.0189C26.5442 20.6261 27.7826 17.5196 27.7826 14.1403C27.7826 6.60504 21.6746 0.49707 14.1393 0.49707C6.60406 0.49707 0.496094 6.60504 0.496094 14.1403C0.496094 21.6756 6.60406 27.7835 14.1393 27.7835C17.5186 27.7835 20.6251 26.5451 23.0179 24.4882L23.5846 25.0759V26.734L34.0794 37.2078L37.2069 34.0804L26.7331 23.5856V23.5856ZM14.1393 23.5856C8.91292 23.5856 4.69401 19.3667 4.69401 14.1403C4.69401 8.91389 8.91292 4.69499 14.1393 4.69499C19.3657 4.69499 23.5846 8.91389 23.5846 14.1403C23.5846 19.3667 19.3657 23.5856 14.1393 23.5856Z",
    stroke: "#0057B2",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SearchIcon.4a6ef503f4171fc45d221fa5915aa875.svg";